import axios from 'axios';
import Vue from 'vue'
import i18n from "@/i18n";

export default {
    
    saveSamllAnnouncment(samllAnnouncment, page, pageSize){
        return axios.post('/api/announcment/save/small', samllAnnouncment , {params : {page:page, pageSize:pageSize}})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.announcement.saveAnnouncment'));
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    findAllSamllAnnouncment(page, pageSize){
        return axios.get('/api/announcment/list/small', {params : {page:page, pageSize:pageSize}})
        .then(response => {
            if (response && response.data) {
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    findAllAlert(){
        return axios.get('/api/announcment/list/alert')
        .then(response => {
            if (response && response.data) {
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },
    
    removeSmallAnnouncement(smallAnnouncementId, page, pageSize){
        return axios.get('/api/announcment/small/remove', {params : {smallAnnouncementId:smallAnnouncementId, page:page, pageSize:pageSize}})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.announcement.removeAnnouncement'));
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

}